import {
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState } from 'react'
import { useLoaderData, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { UserSurveyModel } from 'types'

export default function SurveyEditPage() {
  const { login } = useParams<{ login: string }>()
  const navigate = useNavigate()
  const initialData = useLoaderData() as UserSurveyModel

  const [survey, setSurvey] = useState(initialData)
  const [isSaving, setIsSaving] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    // Convert numeric fields from string to number
    const isNumeric = [
      'how_often_they_read',
      'time_spent_reading',
      'how_often_user_monitors_profile_homeworks',
      'time_spent_monitoring',
    ].includes(name)

    setSurvey((prev) => ({
      ...prev,
      [name]: isNumeric ? Number(value) : value,
    }))
  }

  const handleSubmit = () => {
    setIsSaving(true)
    const token = localStorage.getItem('token')
    // We don't need to send the 'id' in the PUT request body
    const { id, ...payload } = survey

    axios
      .put(`${base_url}/user/${login}/survey`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        alert('Questionnaire mis à jour avec succès !')
        navigate(`/user/${login}`)
      })
      .catch((error) => {
        console.error('Échec de la mise à jour du questionnaire:', error)
        alert(
          'La mise à jour a échoué: ' +
            (error.response?.data?.message || 'Erreur inconnue')
        )
      })
      .finally(() => {
        setIsSaving(false)
      })
  }

  return (
    <PageAppBar pageName={`Modifier le questionnaire pour ${login}`}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          alignItems: 'center',
          padding: '2rem',
          maxWidth: '700px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h5">Modifier le questionnaire</Typography>

        <TextField
          fullWidth
          name="relation_with_profile"
          label="Relation avec le profil"
          value={survey.relation_with_profile}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          name="highest_diploma"
          label="Plus haut diplôme"
          value={survey.highest_diploma}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          name="socio_professional_class"
          label="Classe socio-professionnelle"
          value={survey.socio_professional_class}
          onChange={handleChange}
        />

        <TextField
          fullWidth
          type="number"
          name="how_often_they_read"
          label="Fréquence de lecture (par semaine)"
          value={survey.how_often_they_read}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          type="number"
          name="time_spent_reading"
          label="Temps passé à lire (heures par semaine)"
          value={survey.time_spent_reading}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          type="number"
          name="how_often_user_monitors_profile_homeworks"
          label="Fréquence de suivi des devoirs (par semaine)"
          value={survey.how_often_user_monitors_profile_homeworks}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          type="number"
          name="time_spent_monitoring"
          label="Temps passé au suivi (heures par semaine)"
          value={survey.time_spent_monitoring}
          onChange={handleChange}
        />

        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={isSaving}
          sx={{ mt: 2, minWidth: '150px' }}
        >
          {isSaving ? <CircularProgress size={24} /> : 'Sauvegarder'}
        </Button>
      </Box>
    </PageAppBar>
  )
}
